import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../../neet-j2e/dashboard";
import { Descriptive } from "../../neet-j2e/descriptive";
import { ChatScreen } from "../../neet-j2e/chat-screen";
import { Quiz } from "../../neet-j2e/quiz";
import {
  ROUTE_CHAT,
  ROUTE_LEARNING_ASSETS,
  ROUTE_AI_ANALYSIS,
  ROUTE_QUIZ,
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
  ROUTE_AI_GENERATE,
  ROUTE_PROFILE,
  ROUTE_COMPETITIVE_EXAM,
  ROUTE_DESCRIPTIVE,
  ROUTE_MOCK_TEST,
  // ROUTE_PAYMENT_SUCCESS,
} from "../neetJteRoute.js";
import { Login } from "../../neet-j2e/login";
import { AiGenerator } from "../../neet-j2e/ai-generator";
import { AiAnalysis } from "../../neet-j2e/ai-analysis";
import { LearningAssets } from "../../neet-j2e/learning-assets";
import { CompetitiveExam } from "../../neet-j2e/competitive-exam";
import { Profile } from "../../neet-j2e/profile";
import { MockTest } from "../../neet-j2e/mock-test";
// import { PaymentSuccess } from "../../neet-j2e/payment-success";

export const NeetRoutes = () => (
  <Routes>
    <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
    <Route path={ROUTE_DESCRIPTIVE} element={<Descriptive />} />
    <Route path={ROUTE_CHAT} element={<ChatScreen />} />
    <Route path={ROUTE_QUIZ} element={<Quiz />} />
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={ROUTE_LEARNING_ASSETS} element={<LearningAssets />} />
    <Route path={ROUTE_AI_GENERATE} element={<AiGenerator />} />
    <Route path={ROUTE_AI_ANALYSIS} element={<AiAnalysis />} />
    <Route path={ROUTE_COMPETITIVE_EXAM} element={<CompetitiveExam />} />
    <Route path={ROUTE_PROFILE} element={<Profile />} />
    <Route path={ROUTE_MOCK_TEST} element={<MockTest />} />
    {/* <Route path={ROUTE_PAYMENT_SUCCESS} element={<PaymentSuccess />} /> */}
  </Routes>
);
